//class
import PadCreator from '../../PadCreator';
import BuildPadItem from './BuildPadItem';
// utils
import _ from 'lodash';
import { codeGeneretor, keepObjectProperties } from 'app/utils';
// config
import { PAD_ITEM_TYPE } from '../../../../../../config/pad_item';

/**
 * represents an instance of PadItem
 * @class PadItem
 * @extends PadCreator
 */
export default class PadItemFurniture extends PadCreator {
  prepare(padItemFurnitures, padItemType) {
    const preparedPadItens = padItemFurnitures.map(padItem => {
      const code = codeGeneretor();

      return (
        new BuildPadItem(padItem)
          //.cleanPadItem(keepObjectProperties)
          .addPadItemType(padItemType)
          .addPadItemCode(code)
          .addStatus(1)
          .getPadItem()
      );
    });

    this._loadedData = _.cloneDeep(preparedPadItens);
    this._screenData = _.cloneDeep(preparedPadItens);

    return this;
  }

  /**
   * add a new pad item.
   * @param {object} padItem - padItem to be added.
   * @returns {object} the state
   */
  add(padItem) {
    const cScreenData = _.cloneDeep(this._screenData);
    const cSubmitData = _.cloneDeep(this._submitData);

    const code = codeGeneretor();

    const padItemToAdd = new BuildPadItem(padItem)
      .addPadItemType(PAD_ITEM_TYPE.FURNITURE)
      .addPadItemCode(code)
      .addStatus(1)
      .getPadItem();

    this._screenData = [...cScreenData, padItemToAdd];
    this._submitData = [...cSubmitData, padItemToAdd];

    return this;
  }

  /**
   * update a pad item.
   * @param {object} padItem - padItem to be edited.
   * @returns {object} return the state
   */
  edit(padItem) {
    const screenData = _.cloneDeep(this._screenData);
    const submitData = _.cloneDeep(this._submitData);
    const nPadItem = new BuildPadItem(padItem).setUpdateStatus().getPadItem();

    const indexScreen = screenData.findIndex(pItem => pItem.code === nPadItem.code);
    screenData.splice(indexScreen, 1, nPadItem);

    const indexSubmit = submitData.findIndex(pItem => pItem.code === nPadItem.code);
    submitData.splice(indexSubmit, 1, nPadItem);

    this._screenData = _.cloneDeep(screenData);
    this._submitData = _.cloneDeep(submitData);

    return this;
  }

  /**
   * remove a element.
   * @param {object} padItem - padItem to be removed.
   * @returns {object} return the state
   */
  remove(padItem) {
    const cScreenData = _.cloneDeep(this._screenData);
    const cSubmitData = _.cloneDeep(this._submitData);

    const screenData = cScreenData.filter(pItem => pItem.code !== padItem.code);
    const submitData = cSubmitData.filter(pItem => pItem.code !== padItem.code);

    this._screenData = _.cloneDeep(screenData);
    this._submitData = _.cloneDeep(submitData);

    return this;
  }

  /**
   * appyPredefined a pad item.
   * @param {object} padItem - padItem to be appyPredefined.
   * @returns {object} return the state
   */
  appyPredefinedModel(padItem) {
    const cScreenData = _.cloneDeep(this._screenData);
    const cSubmitData = _.cloneDeep(this._submitData);

    const code = codeGeneretor();

    const padItemToAdd = new BuildPadItem(padItem)
      .cleanPadItem(keepObjectProperties)
      .addPadItemType(PAD_ITEM_TYPE.FURNITURE)
      .addPadItemCode(code)
      .addStatus(1)
      .getPadItem();

    const screenData = [...cScreenData, padItemToAdd];
    const submitData = [...cSubmitData, padItemToAdd];

    this._screenData = _.cloneDeep(screenData);
    this._submitData = _.cloneDeep(submitData);

    return this;
  }
}
